import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Button from './Button';

const NavigationActions = ({ 
  onNext, 
  onPrevious, 
  isNextDisabled = false, 
  isPreviousDisabled = false,
  isLoading = false,
  nextLabel = 'Continue',
  previousLabel = 'Back'
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const steps = [
    { route: '/location-input', nextRoute: '/meeting-point-results' },
    { route: '/meeting-point-results', nextRoute: '/location-type-filter', prevRoute: '/location-input' },
    { route: '/location-type-filter', nextRoute: '/final-meeting-details', prevRoute: '/meeting-point-results' },
    { route: '/final-meeting-details', prevRoute: '/location-type-filter' }
  ];

  const currentStep = steps?.find(step => step?.route === location?.pathname);
  const isFirstStep = !currentStep?.prevRoute;
  const isLastStep = !currentStep?.nextRoute;

  const handleNext = () => {
    if (onNext) {
      onNext();
    } else if (currentStep?.nextRoute) {
      navigate(currentStep?.nextRoute);
    }
  };

  const handlePrevious = () => {
    if (onPrevious) {
      onPrevious();
    } else if (currentStep?.prevRoute) {
      navigate(currentStep?.prevRoute);
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[200] bg-card border-t border-border shadow-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between gap-4">
          <div className="flex-1">
            {!isFirstStep && (
              <Button
                variant="outline"
                onClick={handlePrevious}
                disabled={isPreviousDisabled || isLoading}
                iconName="ChevronLeft"
                iconPosition="left"
                className="w-full sm:w-auto"
              >
                {previousLabel}
              </Button>
            )}
          </div>

          <div className="flex-1 flex justify-end">
            <Button
              variant="default"
              onClick={handleNext}
              disabled={isNextDisabled || isLoading}
              loading={isLoading}
              iconName={isLastStep ? "Check" : "ChevronRight"}
              iconPosition="right"
              className="w-full sm:w-auto"
            >
              {isLastStep ? 'Complete' : nextLabel}
            </Button>
          </div>
        </div>

        <div className="mt-3 text-center">
          <p className="caption text-muted-foreground">
            {isLastStep 
              ? 'Review and confirm your meeting details' :'Continue to the next step when ready'
            }
          </p>
        </div>
      </div>
    </div>
  );
};

export default NavigationActions;